import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Papa from 'papaparse';

// 导出 Excel 的工具函数
export function exportToXlsx({ filename, headers, data }: { filename: string; headers: string[]; data: any[][] }) {
  const sheetData = [headers, ...data];
  const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `${filename}.xlsx`);
}

// 导出 CSV 的工具函数
export function exportToCsv({ filename, headers, data }: { filename: string; headers: string[]; data: any[][] }) {
  // 使用 PapaParse 生成 CSV 字符串
  const csv = Papa.unparse({ fields: headers, data });
  // 创建 Blob 并下载
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, `${filename}.csv`);
}
